module.exports = __webpack_public_path__ + "media/assets/images/blog/polly_block_2-15a26abb7ec9fad4b295cb864050dba3.png";